const filtersToggle = () => {

    /* Toggle elementi search and filter */
    const searchAndFilterToggleEl = document.querySelectorAll('.searchandfilter h4');
    openCloseFilterBox(searchAndFilterToggleEl);

    const queryString = window.location.search;
    let urlParams = false;
    if ( queryString != '' ) {
        urlParams = new URLSearchParams(queryString);
    }
    /* Di base chiudi tutti i filtri */
    searchAndFilterToggleEl.forEach( el => {
        if ( urlParams ) {
            const keys = urlParams.keys();

            if ( urlParams.has(el.parentNode.dataset.sfFieldName) ) {

            }else{
                el.classList.add('closed');
                    el.nextElementSibling.style.display = 'none';
            }
        
        }else{
            el.classList.add('closed');
            el.nextElementSibling.style.display = 'none';
        }

        if(el.closest('li').classList.contains('sf-field-post-meta-_servizi_plus_struttura')){
            el.classList.remove('closed');
            el.nextElementSibling.style.display = 'block';
        }

    });

    /* Toggle elementi custom */
    const customFiltersToggleEl = document.querySelectorAll('.filter_widget_header');
    //openCloseFilterBox(customFiltersToggleEl);

    const filtersSearchInput = document.querySelectorAll('.wpc-filter-search-field');
    filtersSearchInput.forEach( el => {
        el.addEventListener('click', () => {
            let parent = el.closest('.wpc-filter-content');
            let next = parent.querySelector('.wpc-filters-labels');
            next.classList.toggle('opened');
        })
        el.addEventListener('keyup', () => {
            let parent = el.closest('.wpc-filter-search-wrapper');
            if(el.value != ''){
                parent.classList.add('writing');
            }else{
                parent.classList.remove('writing');
            }
        })
    });

    const inputsChecked = document.querySelectorAll('.filters .wpc-filters-widget-main-wrapper input.wpc-label-input:checked + label span.wpc-filter-label-wrapper a');
    inputsChecked.forEach(el => {
        let parent = el.closest('.wpc-filter-content');
        let input = parent.querySelector('.wpc-filter-search-field');
        input.value = el.innerHTML;
        parent.querySelector('.wpc-filter-search-wrapper').classList.add('writing');
        parent.querySelector('.wpc-search-clear').style.display = 'inline-block';
    });


    jQuery(document).on("sf:ajaxfinish", ".searchandfilter", function(){
        jQuery('select.sf-input-select').each( function(index,el) {
        });
    });

    jQuery(document).ready(function($){

        
        jQuery('select.sf-input-select').each( function(index,el) {

            // jQuery(el).chosen({
            //     allow_single_deselect: true
            // });
            // jQuery(el).select2({
            //     theme: "filtercustom",
            //     dropdownParent: jQuery(el).parent(),
            //     //templateResult: formatMe,
            //     placeholder: jQuery(el).find('option:first')[0].innerHTML,
            //     allowClear: true,
            // });
        });

        


        
        
    });

    if(document.querySelector('.vars-reset-filter')){
        document.querySelector('.sf-field-reset').classList.add('d-none');
    }
    var formFilter = document.querySelector('.searchandfilter')
    if(formFilter){
        if(document.querySelector('.sf-field-reset')){
            document.querySelector('.sf-field-reset').style.opacity = '.35';
        }
        var filterSelects = formFilter.querySelectorAll('.sf-input-select');
        filterSelects.forEach(select => {
            var options = select.querySelectorAll('option');
            options.forEach(option => {
                if(option.value && option.selected == true){
                    document.querySelector('.sf-field-reset').classList.add('opacity-100');
                }
            });
        });
    }
}

const openCloseFilterBox = (arr) => {
    arr.forEach( el => {
        el.addEventListener('click', () => {
            if(el.classList.contains('closed')){
                el.classList.remove('closed');
                el.nextElementSibling.style.display = 'block';
            }else{
                el.classList.add('closed');
                el.nextElementSibling.style.display = 'none';
            }
            
        })
    });
}

export default filtersToggle;
